import React, { useState } from "react";
import { Button } from "@chakra-ui/react";
import "./ItemCount.css";

export const ItemCount = ({ stock, initial, onAdd, maxAvailable }) => {
  const [count, setCount] = useState(initial);

  const increase = () => {
    if (count < maxAvailable) {
      setCount(count + 1);
    }
  };
  const decrease = () => {
    if (count > initial) {
      setCount(count - 1);
    }
  };

  return (
    <section className="countContainer">
      <h4 className="count">{count}</h4>
      <Button className="btnIncDec btnInc" onClick={increase}>
        +
      </Button>
      <Button className="btnIncDec btnDec" onClick={decrease}>
        -
      </Button>
      <Button id="btnConfirm" onClick={() => onAdd(count)}>
        Add to cart
      </Button>
    </section>
  );
};
